import { store } from '@betacrew/jars-flux'
export const componentKey = "TWOFA";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setQRCode: (state, action) => {
            state.qrCode = action.payload;
        },
        setLoadingState: (state, action) => {
			state.loadingState = action.payload;
		},
    },
    initialReducerState: {
        qrCode: null,
        loadingState: false,
    }
});
export const { setQRCode, setLoadingState } = actions;